// extracted by mini-css-extract-plugin
export var askAiIcon = "_m9-j";
export var category = "_m9-9";
export var categoryHeader = "_m9-e";
export var container = "_m9-0";
export var group = "_m9-a";
export var groupItems = "_m9-f";
export var groupSeparator = "_m9-k";
export var loading = "_m9-1";
export var noResults = "_m9-3";
export var placeholder = "_m9-2";
export var resultContent = "_m9-5";
export var resultIcon = "_m9-c";
export var resultItem = "_m9-g";
export var resultMeta = "_m9-8";
export var resultSubtitle = "_m9-7";
export var resultSuffix = "_m9-i";
export var resultTitle = "_m9-6";
export var resultsList = "_m9-4";
export var searchGroup = "_m9-d";
export var selected = "_m9-h";
export var subgroup = "_m9-b";